import { useState, useCallback, useEffect } from "react";
import { getInvitations, cancelInvitation, resendInvitation, type Invitation } from "../api/invitations";

export function useInvitations() {
    const [invitations, setInvitations] = useState<Invitation[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [revokingId, setRevokingId] = useState<number | null>(null);

    const refetch = useCallback(async () => {
        setLoading(true);
        setError(null);
        const result = await getInvitations();
        setLoading(false);
        if (Array.isArray(result)) {
            setInvitations(result);
        } else {
            setError(result.error);
        }
    }, []);

    useEffect(() => {
        refetch();
    }, [refetch]);

    const revoke = useCallback(async (inv: Invitation) => {
        if (inv.status !== "pending") return;
        if (!window.confirm(`Revoke invitation for ${inv.email}?`)) return;
        setRevokingId(inv.id);
        const result = await cancelInvitation(inv.id);
        setRevokingId(null);
        if (result.ok) void refetch();
    }, [refetch]);

    const [resendingId, setResendingId] = useState<number | null>(null);

    const resend = useCallback(async (inv: Invitation) => {
        if (inv.status !== "pending") return;
        setResendingId(inv.id);
        const result = await resendInvitation(inv.id);
        setResendingId(null);
        if (result.ok) void refetch();
    }, [refetch]);

    return { invitations, loading, error, refetch, revoke, revokingId, resend, resendingId };
}

